export { getPriceDetails } from './price-details';
